import { render, staticRenderFns } from "./two.vue?vue&type=template&id=454e6391&"
import script from "./two.vue?vue&type=script&lang=js&"
export * from "./two.vue?vue&type=script&lang=js&"
import style0 from "./index.less?vue&type=style&index=0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports